export default function AmenitiesSection() {
  const amenities = [
    {
      icon: "📶",
      title: "High-Speed Wi-Fi",
      description:
        "Reliable internet throughout the property for work, streaming and everyday browsing.",
    },
    {
      icon: "🛏",
      title: "Premium Bedding",
      description:
        "Comfortable beds and quality linens designed for restful nights and longer stays.",
    },
    {
      icon: "🍳",
      title: "Kitchenette",
      description:
        "Prepare meals with ease using a fully equipped private kitchenette.",
    },
    {
      icon: "🧹",
      title: "Housekeeping",
      description:
        "Professional housekeeping keeps your apartment clean and refreshed.",
    },
    {
      icon: "🚗",
      title: "Private Parking",
      description:
        "Convenient on-site parking for guests travelling with their own vehicle.",
    },
    {
      icon: "📍",
      title: "Prime Bengaluru Location",
      description:
        "Minutes from IT parks, hospitals, shopping malls and major transport links.",
    },
  ];

  return (
    <section
      style={{
        background: "#EFE8DD",
        padding: "120px 32px",
      }}
    >
      <div
        style={{
          maxWidth: 1300,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: 70,
          }}
        >
          <p
            style={{
              color: "#C9A66B",
              letterSpacing: ".16em",
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            AMENITIES
          </p>

          <h2
            style={{
              fontFamily: "'Fraunces', serif",
              fontSize: 50,
              color: "#222",
              margin: "18px 0",
            }}
          >
            Everything you need,
            <br />
            thoughtfully provided.
          </h2>

          <p
            style={{
              maxWidth: 720,
              margin: "0 auto",
              color: "#666",
              lineHeight: 1.8,
              fontSize: 18,
            }}
          >
            Designed to make every stay comfortable, productive and memorable,
            whether you're here for a few nights or several weeks.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px,1fr))",
            gap: 28,
          }}
        >
          {amenities.map((item, index) => (
            <div
              key={index}
              style={{
                background: "#FFF",
                padding: 36,
                border: "1px solid #DDD7CC",
                transition: ".35s",
                minHeight: 240,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  fontSize: 36,
                  marginBottom: 24,
                }}
              >
                {item.icon}
              </div>

              <h3
                style={{
                  fontFamily: "'Fraunces', serif",
                  color: "#222",
                  fontSize: 28,
                  marginBottom: 16,
                }}
              >
                {item.title}
              </h3>

              <p
                style={{
                  color: "#666",
                  lineHeight: 1.8,
                  flex: 1,
                }}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}